/* @jsx h */
import { defineComponent, ref, h, computed } from "vue";
import { TableStatus } from "@lemmonhq/types";
import { LemmonModal } from "@app/vue/components/index";
import { useLocalization } from "@lemmonhq/uikit";
import { CartAPI } from "@lemmonhq/orders";
import { NumPad } from "@lemmonhq/uikit";
import { TablePayment } from "@app/vue/pages/Tables/payments/TablePayment";

interface TableSwitcherModalProps {
  cart: CartAPI;
  tables: TableStatus[];
  onClose: () => void;
  onConfirm: (tableId: number, pay?: true) => void;
}

export const TableSwitcherModal = defineComponent<TableSwitcherModalProps>({
  name: "NotesModal",
  props: ["cart", "tables", "onClose", "onConfirm", "tables"],
  setup(props) {
    const tableNumber = ref("");
    const showPaymentModal = ref(false);
    const { t } = useLocalization();

    const matchedTable = computed(() => {
      const str = tableNumber.value;
      const matchingTable =
        str &&
        props.tables.find((el) =>
          el.table.name.match(
            new RegExp(`(^|[\\s\\n])${str}($|[\\s\\n])`, "i"),
          ),
        );
      return matchingTable;
    });

    const handleSubmit = (pay?: true) => {
      if (matchedTable.value) {
        if (pay) {
          showPaymentModal.value = true;
        } else {
          props.onConfirm(matchedTable.value.id);
        }
      }
    };

    return () => (
      <>
        {showPaymentModal.value && matchedTable.value ? (
          <TablePayment
            tableStatus={matchedTable.value}
            onClose={() => {
              showPaymentModal.value = false;
            }}
            onSuccess={(closed) => {
              showPaymentModal.value = false;
              props.onClose();
            }}
          />
        ) : (
          <LemmonModal
            onClose={props.onClose}
            title="Switch Table"
            renderButtons={() => (
              <div class="p-4 border-t ">
                <div class="flex justify-between gap-2">
                  <button
                    onClick={() => props.onClose()}
                    class="btn btn-neutral"
                    type="button"
                  >
                    {t("general.words.cancel")}
                  </button>
                  <div class="flex justify-end items-end flex-1 space-x-2">
                    <button
                      onClick={() => handleSubmit()}
                      class="btn btn-primary"
                      type="submit"
                      disabled={!matchedTable.value}
                    >
                      Open
                    </button>

                    <button
                      onClick={() => {
                        handleSubmit(true);
                      }}
                      class="btn btn-primary"
                      type="submit"
                      disabled={!matchedTable.value}
                    >
                      Pay
                    </button>
                  </div>
                </div>
              </div>
            )}
          >
            <div class="flex flex-col lg:flex-row space-y-2">
              <div class="text-2xl text-center text-accent py-3 lg:w-72 flex justify-center items-center text-center">
                {matchedTable.value ? matchedTable.value.table.name : "-"}
              </div>
              <div class="w-full space-y-6 p-4 mx-auto flex-1 lg:border-l  flex justify-center items-center flex flex-col lg:flex-col">
                <NumPad
                  value={tableNumber.value}
                  onChange={(nv) => {
                    tableNumber.value = nv;
                  }}
                  secureDisplay={false}
                />
              </div>
            </div>
          </LemmonModal>
        )}
      </>
    );
  },
});
